import { connect } from 'react-redux';
import Component from './component';
import { videoCategoriesActions } from '../../../../actions/video-categories';


export default connect(
  state => ({
    items: state.video_categories.list.map(key => state.video_categories.items[key])
  }),
  dispatch => ({
    fetch: () => dispatch(videoCategoriesActions.fetchList())
  })
)(Component);



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/VideoCategorySelector/index.js